module.exports = __webpack_public_path__ + "static/media/logo.2651a517.png";